export default __webpack_public_path__ + "static/startup-b68e21c3133384bed803998630d44a70.svg";